'use strict';

/**
 * Created by stapletont on 25/03/2015.
 */

define(['jquery'], function ($) {

  var _blockNav = {
    /**
     * Module Constructor
     * Dynamically sets positions of different size navigation sections (either left or right of constraint)
     * @private
     */
    _init: function _init() {
      var navigation = $('nav.nav-main');
      var hover = 'hover';

      if ('ontouchstart' in document.documentElement) {
        hover = 'click';
      }

      // Navigation set up
      this._bindEvents({
        parent: navigation,
        type: hover,
        target: '.nav-link',
        whenContains: '.submenu-wrap'
      });
      this._position(navigation);

      // Brands set up
      var brandsDropdown = navigation.find('.brands-dropdown');
      if (brandsDropdown.length) {
        var azList = brandsDropdown.find('.az-list');
        var panels = brandsDropdown.find('.panel');
        this._bindEvents({
          parent: azList,
          type: hover,
          target: 'li'
        }, function (element) {
          _blockNav._showPanel(element, panels);
          return false;
        });
        this._generateBrands(brandsDropdown, azList);
        this._showPanel($(azList.find('li')[0]), panels);
      }
    },

    /**
     * Bind events to top level navigation links
     * @param {object} config - parent: jQuery selector, type: Event type, target: CSS selector
     * @param {function} [callback] - Function to run on event enter
     * @private
     */
    _bindEvents: function _bindEvents(config, callback) {
      config.parent.on(config.type, config.target, function (e) {
        var element = $(this);
        var containsCheck = 1;

        if (config.whenContains) {
          containsCheck = element.find(config.whenContains).length;
        }

        if (config.type === 'click' && containsCheck) {
          element.mouseleave(function () {
            config.parent.find(config.target).removeClass('active');
            element.removeClass('active');
          });
          return _blockNav._touchHandler(element, config, callback);
        }

        if (e.type === 'mouseenter') {
          element.addClass('active');
          if (callback) {
            callback(element);
          }
        } else {
          element.removeClass('active');
        }
      });
    },

    /**
     * Handle touch devices
     * @param element
     * @param config
     * @param {function} [callback]
     * @returns {boolean}
     * @private
     */
    _touchHandler: function _touchHandler(element, config, callback) {
      if (element.hasClass('active')) {
        element.removeClass('active');
        return true;
      }

      config.parent.find(config.target).removeClass('active');
      element.addClass('active');

      if (callback) {
        callback(element);
      }
      return false;
    },

    /**
     * Position the nav relative to the position of the link
     * @param {object} navigation - Main Navigation
     * @private
     */
    _position: function _position(navigation) {
      var navigationWidth = navigation.width();
      navigation.find('.submenu-wrap').each(function () {
        var submenu = $(this);
        var submenuWidth = submenu.width();

        if (navigationWidth === submenuWidth) {
          return;
        }

        var parentLink = submenu.closest('.nav-link');
        var parentLinkPosition = parentLink.position();
        var parentLinkWidth = parentLink.width();
        parentLinkPosition.left = Math.floor(parentLinkPosition.left);

        if (parentLinkPosition.left > navigationWidth / 2) {
          if (submenuWidth / 2 < navigationWidth - parentLinkPosition.left - parentLinkWidth) {
            submenu.css({
              left: parentLinkPosition.left - submenuWidth / 2,
              right: 'auto'
            });
            return;
          }
          submenu.css({
            right: 0,
            left: 'auto'
          });
          return;
        }

        if (submenuWidth / 2 < parentLinkPosition.left) {
          if (submenuWidth / 2 < navigationWidth - parentLinkPosition.left - parentLinkWidth) {
            submenu.css({
              left: parentLinkPosition.left - submenuWidth / 2,
              right: 'auto'
            });
            return;
          }
          submenu.css({
            left: submenuWidth / 2
          });
          return;
        }
        submenu.css({
          left: 0
        });
      });
    },

    /**
     * Create A-Z list
     * @param brandsDropdown
     * @param azList
     * @private
     */
    _generateBrands: function _generateBrands(brandsDropdown, azList) {
      // Faster than handlebars and not dynamic enough to need it
      var documentFrag = document.createDocumentFragment();
      var titles = brandsDropdown.find('.tabs-title');
      titles.each(function (index) {
        var element = $(this);
        var li = document.createElement('li');
        li.id = index;
        li.innerHTML = element[0].innerHTML;
        documentFrag.appendChild(li);
      });
      azList.prepend(documentFrag);
    },

    /**
     * Show panel
     * @param element
     * @param panels
     * @private
     */
    _showPanel: function _showPanel(element, panels) {
      panels.removeClass('active');
      var panelNumber = Number(element.attr('id'));
      for (var i = 0; i < panels.length; i++) {
        if (i === panelNumber) {
          $(panels[i]).addClass('active');
          return;
        }
      }
    }
  };

  // Execute module constructor
  _blockNav._init();
  return _blockNav;
});
//# sourceMappingURL=block-nav.js.map
